export default __webpack_public_path__ + "static/media/authenFailed.6b080663.svg";